import { configureStore } from '@reduxjs/toolkit';

import contactFormReducer from './contactForm/contactFormSlice';
import pageLoaderReducer from './pageLoader/pageLoaderSlice';
import serverReducer from './server/serverSlice';

export const rootReducer = {
	server: serverReducer,
	contactForm: contactFormReducer,
	pageLoader: pageLoaderReducer
};

export const store = configureStore({
	reducer: rootReducer
});
